export enum PDFSectionsResolution886 {
	IDENTIFICATION_RISK_FACTORS = 'identification_risk_factors',
	IDENTIFICATION_CORRECTIVE_PREVENTIVE_MEASURES = 'identification_corrective_preventive_measures',
	FOLLOW_UP_PREVENTIVE_MEASURES = 'follow_up_preventive_measures',
	COMMENT = 'comment',
	TASK_EVALUATIONS = 'task_evaluations',
	TASK_RISK_EVALUATION = 'task_risk_evaluation',
	TASK_ACTION_PLAN = 'task_action_plan',
	TASK_INITIAL_EVALUATION_RISK_FACTORS = 'task_initial_evaluation_risk_factors'
}

export enum Risk {
	TOLERABLE = 'TOLERABLE',
	MODERATE = 'MODERATE',
	NOT_TOLERABLE = 'NOT_TOLERABLE'
}

export type RiskType = Risk | 'TOLERABLE' | 'MODERATE' | 'NOT_TOLERABLE';

export enum StepsResolution886 {
	VIDEO_SELECTION = 0,
	GENERAL_INFORMATION = 1,
	ASSESSMENT = 2,
	ACTION_PLAN = 3,
	RESULT = 4
}

export enum SIDE {
	LEFT = 'left',
	RIGHT = 'right'
}

export enum DIRECTION {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal'
}

export enum AdditionalEvaluationOption {
	LATERAL_LONGITUDINAL_MOVEMENT = 'lateral_longitudinal_movement',
	VERTICAL_MOVEMENT = 'vertical_movement'
}

export enum AdditionalEvaluation {
	HAND_ARM_VIBRATION_EXPOSURE = 'hand_arm_vibration_exposure',
	WHOLE_BODY_VIBRATION_EXPOSURE = 'whole_body_vibration_exposure'
}

export enum ErgonomicToolKeys {
	NIOSH = 'niosh',
	KIM_PP = 'kim_pp',
	STRAIN_INDEX = 'strain_index',
	REBA = 'reba',
	LIBERTY_MUTUAL = 'liberty_mutual',
	JDS_D86 = 'jds_d86'
}

export enum ErgonomicToolNames {
	NIOSH = 'NIOSH / ISO 11228-1',
	KIM_PP = 'KIM PUSH PULL',
	STRAIN_INDEX = 'STRAIN INDEX',
	REBA = 'REBA',
	LIBERTY_MUTUAL = 'LIBERTY MUTUAL',
	JDS_D86 = 'JDS-D86'
}

export enum EvaluationCategoryKeys {
	LIFT_AND_LOWER = 'lift_and_lower',
	PUSH_PULL = 'push_pull',
	TRANSPORT = 'transport',
	REPETITIVE_MOVEMENTS = 'repetitive_movements',
	FORCED_POSTURE = 'forced_posture',
	HAND_ARM_VIBRATION = 'hand_arm_vibration',
	WHOLE_BODY_VIBRATION = 'whole_body_vibration',
	THERMAL_COMFORT = 'thermal_comfort',
	CONTACT_STRESS = 'contact_stress',
	STANDING = 'standing'
}

export enum EvaluationCategoryNames {
	LIFT_AND_LOWER = 'Lift and lower',
	PUSH_PULL = 'Push / pull',
	TRANSPORT = 'Transport',
	REPETITIVE_MOVEMENTS = 'Repetitive movements',
	FORCED_POSTURE = 'Forced posture',
	HAND_ARM_VIBRATION = 'Hand-arm vibration',
	WHOLE_BODY_VIBRATION = 'Whole body vibration',
	THERMAL_COMFORT = 'Thermal comfort',
	CONTACT_STRESS = 'Contact stress',
	STANDING = 'Standing'
}
